// extracted by mini-css-extract-plugin
module.exports = {"settingCotainer":"listPickMob_settingCotainer__1XZIm","settingDots":"listPickMob_settingDots__kyOf0"};